import React, { useState, useEffect } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

const AlertMessage = ({ message= "Ihr Orderbuch wurde hochgeladen", severity = "success", timeout = 2000 }) => {
  const [showAlert, setShowAlert] = useState(true);

  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, timeout);

      return () => clearTimeout(timer); // Cleanup on unmount or re-render
    }
  }, [showAlert, timeout]);

  if (!showAlert) {
    return null; // Don't render anything when showAlert is false
  }

  return (
    <Alert severity={severity} style={{
                                width: '60%',
                                height: 'auto', // Allow content to dictate height
                                margin: '4% auto' // Center the component
                            }}>
      <AlertTitle>{severity.charAt(0).toUpperCase() + severity.slice(1)}</AlertTitle>
      {message}
    </Alert>
  );
};


export default AlertMessage;